export const formatToThousands = (number, decimals = 2) => {
	const insertDots = (num) => {
		const numStr = num.toString()
		const reversedStr = numStr.split('').reverse().join('') // Reverse the string to apply regex from right to left
		const chunks = reversedStr.replace(/(\d{3}(?!$))/g, '$1.') // Insert dot every three digits, except at the end
		return chunks.split('').reverse().join('') // Reverse back to original order
	}

	if (!number && number !== 0) return ''
	if (typeof number === 'string') number = parseFloat(number)

	const n = Number(number || 0).toFixed(decimals)

	// Split the number into integer and fraction parts
	const parts = n.split('.')

	// Format the integer part with the system locale
	// const integerPart = Number(parts[0]).toLocaleString();
	const integerPart = insertDots(parseInt(parts[0]))

	// The fraction part is already rounded to two digits by toFixed
	const fractionPart = parts[1]

	// Combine the two parts and return
	return integerPart + ',' + fractionPart
}
